"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteStoreItemMappingDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@goparrot/common");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const class_transformer_1 = require("class-transformer");
const mongodb_1 = require("mongodb");
class DeleteStoreItemMappingDto {
}
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.MODEL, common_1.DefaultExposeGroupEnum.DELETE] }),
    tslib_1.__metadata("design:type", mongodb_1.ObjectId)
], DeleteStoreItemMappingDto.prototype, "_id", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiProperty)({ type: () => String, example: '77s1gcn7-15bf-4aeg-1331-4eafbbd12921' }),
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ, common_1.DefaultExposeGroupEnum.MODEL, common_1.DefaultExposeGroupEnum.DELETE] }),
    tslib_1.__metadata("design:type", String)
], DeleteStoreItemMappingDto.prototype, "merchantId", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiProperty)({ type: () => String, example: '77s1gcn7-15bf-4aeg-1331-4eafbbd12921' }),
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ, common_1.DefaultExposeGroupEnum.MODEL, common_1.DefaultExposeGroupEnum.DELETE] }),
    tslib_1.__metadata("design:type", String)
], DeleteStoreItemMappingDto.prototype, "storeId", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiProperty)({ type: () => String, example: '77s1gcn7-15bf-4aeg-1331-4eafbbd12921' }),
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ, common_1.DefaultExposeGroupEnum.MODEL, common_1.DefaultExposeGroupEnum.DELETE] }),
    tslib_1.__metadata("design:type", String)
], DeleteStoreItemMappingDto.prototype, "centralUniqueName", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiProperty)({ type: () => String, example: '77s1gcn7-15bf-4aeg-1331-4eafbbd12921' }),
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ, common_1.DefaultExposeGroupEnum.MODEL, common_1.DefaultExposeGroupEnum.DELETE] }),
    tslib_1.__metadata("design:type", String)
], DeleteStoreItemMappingDto.prototype, "replicaUniqueName", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.MODEL, common_1.DefaultExposeGroupEnum.DELETE] }),
    tslib_1.__metadata("design:type", Date)
], DeleteStoreItemMappingDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.MODEL, common_1.DefaultExposeGroupEnum.DELETE] }),
    tslib_1.__metadata("design:type", Date)
], DeleteStoreItemMappingDto.prototype, "updatedAt", void 0);
exports.DeleteStoreItemMappingDto = DeleteStoreItemMappingDto;
//# sourceMappingURL=DeleteStoreItemMappingDto.js.map